import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ChatComponent } from './chat.component';
import { ChatHolderComponent } from './chat-holder/chat-holder.component';

const routes: Routes = [
  {
    path: '',
    component: ChatComponent,
    children: [
      {
        path: '',
        component: ChatHolderComponent
      },
    //   {
    //     path: 'canvas',
    //     component: ECanvasComponent
    //   },
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class chatRoutingModule { }
